<template>
<div class="datetime">
    <input type="text" class="form-control inputElement" :id="'value-'+id" :value="value" autocomplete="off">
</div>
</template>

<script>
import "eonasdan-bootstrap-datetimepicker"
import "eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css"
export default {
  name: "DateInput",
  data() {
    return {
      output: {}
    };
  },
  mounted() {
       $('#value-'+this.id).datetimepicker({
           format: 'DD.MM.YYYY H:mm',
          // format: 'YYYY.MM.DD H:mm',
           locale: 'de'
    });
  },
  props: ["value", "id"]
};
</script>

<style scoped>
.datetime {
position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/input/DatetimeInput.vue